var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaretRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 515,
    viewBox: "0 0 289 515",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75997 504.907C15.5985 510.745 23.5146 514.032 31.7706 514.032C40.031 514.032 47.948 510.745 53.7813 504.907L279.341 279.347C285.185 273.513 288.466 265.592 288.466 257.336C288.466 249.08 285.185 241.159 279.341 235.325L53.7813 9.76531C45.922 1.90078 34.4586 -1.16696 23.7133 1.70798C12.9737 4.58824 4.58262 12.9788 1.70262 23.7186C-1.17232 34.4634 1.89534 45.9266 9.75997 53.7866L213.307 257.333L9.75997 460.88C3.92144 466.713 0.634888 474.629 0.634888 482.891C0.634888 491.146 3.9213 499.063 9.75997 504.901V504.907Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/caretRight.d80da07d71be66ea401dd34a0f9e2f57.svg";
export { ForwardRef as ReactComponent };